// extracted by mini-css-extract-plugin
module.exports = {"price":"price-2UlRg","edit":"edit-2K98c","button":"button-2-6FP"};